import React, { useEffect, useState } from 'react';
import { lazy, Suspense } from "react";
//Components 

import LatestNewsSlider from './../components/Home/LatestNewsSlider';
import NewsLetter from './../components/NewsLetter';
import { Helmet } from 'react-helmet-async';

//element 
import CounterSection from './../elements/CounterSection';
import DownloadApp from '../components/DownloadApp';
import HomeMainSlider from '../components/Home/HomeMainSlider';
const ClientsSlider = lazy(() => import('./../components/Home/ClientsSlider'));
const RecomendedSlider = lazy(() => import('./../components/Home/RecomendedSlider'));
const BookSaleSlider = lazy(() => import('./../components/Home/BookSaleSlider'));
const FeaturedSlider = lazy(() => import('./../components/Home/FeaturedSlider'));
const OfferSlider = lazy(() => import('./../components/Home/OfferSlider'));
const TestimonialSlider = lazy(() => import('./../components/Home/TestimonialSlider'));


const iconBlog = [
	{
		title: 'Made by Students',
		desc: 'Every piece is handcrafted by a student putting heart and effort into their work.',
		iconClass: 'flaticon-open-book'
	},
	{
		title: 'Carefully Selected',
		desc: 'Only meaningful and high-quality creations are chosen to be showcased.',
		iconClass: 'flaticon-like'
	},
	{
		title: 'Gift with Purpose',
		desc: 'Your purchase supports a student’s dream and makes your gift more meaningful.',
		iconClass: 'flaticon-star'
	},
	{
		title: 'Trusted Experience',
		desc: 'Safe payments and reliable delivery, so you can shop with confidence.',
		iconClass: 'flaticon-shield'
	},
];

function Index1() {
	const [showAppPopup, setShowAppPopup] = useState(false);

	useEffect(() => {

		const isMobile = window.innerWidth <= 768;

		if (!isMobile) return;

		const hasSeenPopup = sessionStorage.getItem('appPopupSeen');

		if (!hasSeenPopup) {
			const timer = setTimeout(() => {
				setShowAppPopup(true);
			}, 3000);

			return () => clearTimeout(timer);
		}

	}, []);

	const handleClosePopup = () => {
		setShowAppPopup(false);
		sessionStorage.setItem('appPopupSeen', 'true');
	};

	const playStoreLink = "https://play.google.com/store/apps/details?id=com.arttokri.app";
	const appStoreLink = "https://apps.apple.com/app/id6761808592";

	return (
		<>
			<Helmet>
				<title>Art Tokri – Buy Handmade Gifts Online | Student Marketplace</title>

				<meta
					name="description"
					content="Buy handmade products online worldwide made by student creators. Discover unique gifts and support young artists globally with ArtTokri."
				/>

				<meta name="keywords" content="student art, handmade gifts, art tokri, student creators, unique gifts" />

				<meta property="og:title" content="ArtTokri - Student Creations Marketplace" />
				<meta property="og:description" content="Support student creators by buying meaningful handmade products." />
				{/* Canonical */}
				<link rel="canonical" href="https://arttokri.com/" />
			</Helmet>

			<div className="page-content bg-white homepage-premium">
				<div className="main-slider style-1 homepage-hero">
					<HomeMainSlider />
				</div>
				<div className="bg-white homepage-clients-strip" style={{ padding: "35px 0 15px" }}>
					<div className="container">
						<Suspense fallback={null}>
							<ClientsSlider />
						</Suspense>
					</div>
				</div>
				<section className="content-inner-1 reccomend homepage-section homepage-section-featured-products" style={{ background: "transparent" }}>
					<div className="container">
						<div className="section-head text-center homepage-section-head">
							<h2 className="title"> Featured Handmade Products by Student Creators</h2>
							<p>
								Explore a curated collection of student made products, including handmade paintings, greeting cards, and creative crafts.
							</p>
						</div>
						<div className="homepage-section-shell homepage-slider-shell">
							<Suspense fallback={null}>
								<RecomendedSlider />
							</Suspense>
						</div>
					</div>
				</section>

				<section className="content-inner-2 homepage-section homepage-section-trust">
					<div className="container">
						<div className="row">
							{iconBlog.map((data, ind) => (
								<div className="col-lg-3 col-sm-6" key={ind}>
									<div className="icon-bx-wraper style-1 m-b30 text-center homepage-trust-card">
										<div className="icon-bx-sm m-b10 homepage-trust-icon">
											<i className={`icon-cell ${data.iconClass}`} />
										</div>
										<div className="icon-content homepage-trust-content">
											<p className="dz-title m-b10"><strong>{data.title}</strong></p>
											<p>{data.desc}</p>
										</div>
									</div>
								</div>
							))}
						</div>
					</div>
				</section>
				<section className="content-inner-1 homepage-section homepage-section-sale">
					<div className="container">
						<div className="homepage-section-shell homepage-slider-shell">
							<Suspense fallback={null}>
								<BookSaleSlider />
							</Suspense>
						</div>
					</div>
				</section>
				<section className="content-inner-1 bg-grey reccomend homepage-section homepage-section-artworks">
					<div className="container">
						<div className="section-head text-center homepage-section-head">
							<div className="circle style-1"></div>
							<h2 className="title">Featured Artworks</h2>
							<p>This stunning handmade painting is crafted by a talented student and available for worldwide delivery.  </p>
						</div>
					</div>
					<div className="container">
						<div className="homepage-section-shell homepage-featured-shell">
							<Suspense fallback={null}>
								<FeaturedSlider />
							</Suspense>
						</div>
					</div>
				</section>
				<section className="content-inner-2 homepage-section homepage-section-creators">
					<div className="container">
						<div className="homepage-section-shell homepage-slider-shell">
							<Suspense fallback={null}>
								<OfferSlider />
							</Suspense>
						</div>
					</div>
				</section>
				<section className="content-inner-2 testimonial-wrapper homepage-section homepage-section-testimonials">
					<div className="container">
						<div className="homepage-section-shell homepage-testimonial-shell">
							<Suspense fallback={null}>
								<TestimonialSlider />
							</Suspense>
						</div>
					</div>
				</section>
				{/* <section className="content-inner-2">
					<div className="container">
						<div className="section-head text-center">
							<h2 className="title">Latest News</h2>
							<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua</p>
						</div>
						<LatestNewsSlider />
					</div>
				</section> */}
				<section className="content-inner homepage-section homepage-section-counter">
					<div className="container">
						<div className="row sp15 homepage-counter-shell">
							<CounterSection />
						</div>
					</div>
				</section>
				<DownloadApp />
				<NewsLetter />

				{/* {showAppPopup && (
					<div className="app-install-popup-overlay" onClick={handleClosePopup}>
						<div className="app-install-popup" onClick={(e) => e.stopPropagation()}>
							<button className="popup-close-btn" onClick={handleClosePopup}>
								<i className="fa-solid fa-xmark"></i>
							</button>
							<div className="popup-content">
								<h3>Get the ArtTokri App</h3>
								<p>For a better experience, install our app</p>
								<div className="popup-buttons">
									<a href={playStoreLink} target="_blank" rel="noopener noreferrer" className="popup-btn google-btn">
										<i className="fa-brands fa-google-play"></i>
										<span>Google Play</span>
									</a>
									<a href={appStoreLink} target="_blank" rel="noopener noreferrer" className="popup-btn apple-btn">
										<i className="fa-brands fa-apple"></i>
										<span>App Store</span>
									</a>
								</div>
							</div>
						</div>
					</div>
				)} */}
			</div>

			<style>{`
				.homepage-premium {
					position: relative;
				}
				.homepage-premium .container {
					position: relative;
					z-index: 1;
				}
				.homepage-section {
					position: relative;
				}
				.homepage-clients-strip {
					position: relative;
					z-index: 2;
				}
				.homepage-section-head {
					margin-bottom: 28px;
				}
				.homepage-section-head .title {
					margin-bottom: 10px;
					letter-spacing: -0.03em;
				}
				.homepage-section-head p {
					max-width: 720px;
					margin: 0 auto;
					font-size: 15px;
					line-height: 1.75;
					color: #667085;
				}
				.homepage-section-shell {
					border-radius: 28px;
					border: 1px solid rgba(240, 90, 40, 0.08);
					background: linear-gradient(180deg, rgba(255,255,255,0.97), rgba(255,248,243,0.92));
					box-shadow: 0 22px 60px rgba(17, 24, 39, 0.08);
					padding: 24px 22px;
					overflow: hidden;
				}
				.homepage-slider-shell {
					backdrop-filter: blur(10px);
				}
				.homepage-featured-shell {
					padding: 28px 24px;
				}
				.homepage-testimonial-shell {
					padding: 6px 0 26px;
				}
				.homepage-trust-card {
					height: 100%;
					padding: 28px 22px 24px;
					border-radius: 24px;
					background: linear-gradient(180deg, rgba(255,255,255,0.98), rgba(255,249,244,0.95));
					border: 1px solid rgba(240, 90, 40, 0.08);
					box-shadow: 0 16px 36px rgba(17, 24, 39, 0.07);
					transition: transform 0.28s ease, box-shadow 0.28s ease, border-color 0.28s ease;
				}
				.homepage-trust-card:hover {
					transform: translateY(-6px);
					box-shadow: 0 24px 42px rgba(17, 24, 39, 0.12);
					border-color: rgba(240, 90, 40, 0.16);
				}
				.homepage-trust-icon {
					width: 72px;
					height: 72px;
					margin: 0 auto 16px;
					border-radius: 20px;
					display: flex;
					align-items: center;
					justify-content: center;
					background: linear-gradient(180deg, rgba(240, 90, 40, 0.12), rgba(245, 166, 35, 0.08));
					box-shadow: inset 0 1px 0 rgba(255,255,255,0.85);
				}
				.homepage-trust-icon .icon-cell {
					font-size: 28px;
				}
				.homepage-trust-content .dz-title {
					font-size: 19px;
					line-height: 1.3;
					color: #18212f;
				}
				.homepage-trust-content p:last-child {
					margin-bottom: 0;
					font-size: 14px;
					line-height: 1.7;
					color: #667085;
				}
				.homepage-section-testimonials .testimonial {
					margin-bottom: 0;
				}
				.homepage-section-testimonials .container.mt-5 {
					margin-top: 0 !important;
				}
				.homepage-counter-shell {
					padding: 10px 0 0;
				}
				.homepage-section-featured-products,
				.homepage-section-sale,
				.homepage-section-artworks,
				.homepage-section-creators,
				.homepage-section-testimonials,
				.homepage-section-counter {
					scroll-margin-top: 110px;
				}
				.app-install-popup-overlay {
					position: fixed;
					top: 0;
					left: 0;
					right: 0;
					bottom: 0;
					background: rgba(0, 0, 0, 0.6);
					z-index: 9999;
					display: flex;
					align-items: center;
					justify-content: center;
					animation: fadeIn 0.3s ease;
				}
				.app-install-popup {
					background: white;
					border-radius: 16px;
					padding: 30px;
					max-width: 400px;
					width: 90%;
					text-align: center;
					position: relative;
					animation: slideUp 0.3s ease;
					box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
				}
				.popup-close-btn {
					position: absolute;
					top: 10px;
					right: 10px;
					background: none;
					border: none;
					font-size: 20px;
					cursor: pointer;
					color: #666;
					padding: 5px;
				}
				.popup-close-btn:hover {
					color: #333;
				}
				.popup-content h3 {
					font-size: 24px;
					font-weight: 700;
					color: #333;
					margin-bottom: 10px;
				}
				.popup-content p {
					font-size: 16px;
					color: #666;
					margin-bottom: 25px;
				}
				.popup-buttons {
					display: flex;
					gap: 15px;
					justify-content: center;
					flex-wrap: wrap;
				}
				.popup-btn {
					display: flex;
					align-items: center;
					gap: 8px;
					padding: 12px 24px;
					border-radius: 8px;
					text-decoration: none;
					font-weight: 600;
					font-size: 14px;
					transition: transform 0.2s ease;
				}
				.popup-btn:hover {
					transform: scale(1.05);
				}
				.google-btn {
					background: #000;
					color: white;
				}
				.apple-btn {
					background: #000;
					color: white;
				}
				@keyframes fadeIn {
					from { opacity: 0; }
					to { opacity: 1; }
				}
				@keyframes slideUp {
					from { transform: translateY(20px); opacity: 0; }
					to { transform: translateY(0); opacity: 1; }
				}
				@media (max-width: 480px) {
					.homepage-section-head {
						margin-bottom: 22px;
					}
					.homepage-section-head .title {
						font-size: 28px;
						line-height: 1.15;
					}
					.homepage-section-head p {
						font-size: 14px;
						line-height: 1.65;
					}
					.homepage-section-shell,
					.homepage-featured-shell {
						padding: 16px 14px;
						border-radius: 20px;
					}
					.homepage-testimonial-shell {
						padding: 0 0 18px;
					}
					.homepage-trust-card {
						padding: 22px 16px 18px;
						border-radius: 18px;
					}
					.homepage-trust-icon {
						width: 60px;
						height: 60px;
						border-radius: 16px;
					}
					.homepage-trust-content .dz-title {
						font-size: 17px;
					}
					.app-install-popup {
						padding: 20px;
					}
					.popup-content h3 {
						font-size: 20px;
					}
					.popup-buttons {
						flex-direction: column;
					}
					.popup-btn {
						justify-content: center;
					}
				}
				@media (min-width: 481px) and (max-width: 991px) {
					.homepage-section-shell,
					.homepage-featured-shell {
						padding: 20px 18px;
						border-radius: 24px;
					}
					.homepage-trust-card {
						padding: 24px 18px 20px;
					}
				}
			`}</style>
		</>
	)
}
export default Index1;
